<template>
  <li class="activity-list-item" :class="['size-' + size]">
    <span class="line" aria-hidden="true"></span>
    <div @click="openItem()" class="list-item-content">
      <div class="item-icon">
        <div class="item-icon--action" :class="iconClass(item, 'grammar_type')" v-html="itemIcon(item.grammar_type)" />
        <span v-if="item.type === 'action'" class="item-icon--grammar" :class="iconClass(item, 'object_type')" v-html="itemIcon(item.object_type)" />
        <span v-else class="item-icon--notification" />
      </div>
      <div class="item-description">
        <p class="item-description--action" v-html="itemText" />
        <div class="item-description--date">
          <time :datetime="item.event_time">{{ itemDate }}<span class="item-year">{{ itemYear }}</span></time>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from 'moment';
export default {
  props: {
    item: {
      type: Object,
      default: () => {} 
    },
    size: {
      type: String,
      default: 'sm'
    }
  },
  computed: {
    itemText () {
      const time = new Date(this.item.event_time).toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit' })

      let itemtext = this.item.grammar
                      .replace('%user', this.item.user_name)
                      .replace('%object_type_name', this.item.object_type_name)
                      .replace('%object_name', this.item.object_name)
                      + ' ' + this.$gettext('at') + ' ' + time

      if (this.item.object_type === 'gekko_notification') {
        itemtext = this.$gettext('You received a new') + ' ' + this.item.object_type_name + ' ' + this.$gettext('at') + ' ' + time
      }
      return itemtext
    },
    itemDate () {
      return moment(new Date(this.item.event_time)).format('MMM DD') 
    },
    itemYear () {
      return moment(new Date(this.item.event_time)).format('YYYY') 
    },
    ...mapGetters({ 
      getGekkoNotification: "notifications/getGekkoNotification"
    }),
  },
  methods: {
    ...mapActions({ 
      toggleStatus: "notifications/toggleNotificationStatus",
      openModal: "dashboard/openModal",
    }),
    openItem () {
      if (this.item.type === 'notification' && this.item.status === 'unseen') {
        this.toggleStatus(this.item.id)
        if (this.item.object_type !== 'team_invite') this.item.status = 'seen'
      }
      this.openModal(this.item)
    },
    itemIcon (kind) {
      let icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>'
      switch (kind) {
        case 'notification': // icon bell
        case 'gekko_notification': // icon bell
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" /></svg>'
          break;
        case 'hero_status_cancelled':
        case 'invite_rejected':
        case 'rejected':
        case 'deleted':
        case 'invited':
        case 'sent_invite_rejected':
        case 'sent_invite_pending':
        case 'copied':
        case 'team_member_disconnected':
        case 'created': // icon plus/cross
          icon = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6m0 0v6m0-6h6m-6 0H6" /></svg>'
          break;
        case 'delivery': // icon exclamation
          icon = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>'
          break;
        case 'change':
        case 'edited': // icon pencil
          icon = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"><path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" /></svg>'
          break;
        case 'cost': // icon shopping cart
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" /></svg>'
          break;
        case 'document':
        case 'quotation':
        case 'correction':
        case 'invoice_payment':
        case 'invoice': // icon document
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clip-rule="evenodd" /></svg>'
          break;
        case 'trip': // icon map marker
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" /></svg>'
          break;
        case 'hour': // icon clock
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" /></svg>'
          break;
        case 'contact': // icon heart
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd" /></svg>'
          break;
        case 'user': // icon star used for HEROES program actions
          icon = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6"><path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" /></svg>'
          break;
        case 'hero_status_activated':
        case 'hero_signup_accepted':
        case 'sent_invite_accepted':
        case 'invite_accepted':
        case 'accepted':
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>'
          break;
        case 'invoice_paid':
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>'
          break;
        case 'shared':
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" /></svg>'
          break;
        case 'reminder_sent':
        case 'sent':
        case 'marked_sent':
        case 'email': // icon envelope
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>';
          break;
        case 'team_invite':
        case 'accountant_invite':
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"><path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" /></svg>'
          break;
        default: // default icon -> info
          icon = '<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>'
          break;
      }
      return icon 
    },
    iconClass (item, type) {
      return type + '-' + item[type]
    }
  }
}
</script>

<style lang="scss">
  li.activity-list-item {
    position: relative;
    padding-bottom: 1rem;
    &:hover {
      .list-item-content {
        background: #f6f6f6;
        text-decoration: none;
      }
    }
    .line {
      background: #e5e7eb;
      position: absolute;
      width: 2px;
      height: 100%;
      left: 20px;
      top: 20px;
    }
    .list-item-content {
      display: flex;
      align-items: center;
      cursor: pointer;

      border-radius: 8px;
      padding: 4px;
      transition: background-color 0.1s ease; 
      
      .item-icon {
        position: relative;
        &--action {
          height: 35px;
          width: 35px;
          border-radius: 100%;
          
          display: flex;
          justify-content: center;
          align-items: center;
          
          svg {
            display: block;
            width: 25px;
            height: 25px;
          }

          /* default icon colors */
          background: white;
          color: white;
          
          &.grammar_type-hero_status_activated,
          &.grammar_type-hero_signup_accepted,
          &.grammar_type-invite_accepted,
          &.grammar_type-sent_invite_accepted,
          &.grammar_type-accepted,
          &.grammar_type-copied,
          &.grammar_type-created {
            background: #88ddb6;
          }
          &.grammar_type-edited {
            background: #fdc885;
          }
          &.grammar_type-delivery {
            background: #fdacab;
          }
          &.grammar_type-hero_status_cancelled,
          &.grammar_type-rejected,
          &.grammar_type-invite_rejected,
          &.grammar_type-sent_invite_rejected,
          &.grammar_type-team_member_disconnected,
          &.grammar_type-deleted {
            transform: rotate(45deg);
            background: #fdacab;
          }
          &.grammar_type-team_invite,
          &.grammar_type-accountant_invite,
          &.grammar_type-sent_invite_pending,
          &.grammar_type-notification,
          &.grammar_type-invited,
          &.grammar_type-shared,
          &.grammar_type-sent,
          &.grammar_type-reminder_sent,
          &.grammar_type-marked_sent,
          &.grammar_type-email,
          &.grammar_type-change {
            background: #b1e0fb;
          }
        }
        &--notification {
          content: "";
          width: 8px;
          height: 8px;
          position: absolute;
          border-radius: 100%;
          background: #EC602C;
          top: 22px;
          right: 5px;
          z-index: 10;
          // outline: 2px solid white;
          box-shadow: 0px 0px 0px 2px white;
          transition: inherit;
        }
        &--grammar {
          position: absolute;
          bottom: -3px;
          right: -6px;
          border-radius: 100%;
          padding: 3px;
          color: white;
          background: red;
          svg {
            display: block;
            width: 15px;
            height: 15px;
          }

          &.default-info {
            color: $colorAppCosts;
          }
          &.object_type-cost {
            background: white;
            color: $colorAppCosts;
          }
          &.object_type-trip {
            background: white;
            color: $colorAppTrips;
          }
          &.object_type-team_invite,
          &.object_type-accountant_invite,
          &.object_type-correction,
          &.object_type-document,
          &.object_type-quotation,
          &.object_type-invoice_payment,
          &.object_type-invoice {
            background: white;
            color: $colorAppInvoices;
          }
          &.object_type-user {
            background: white;
            color: $colorGold;
          }
          &.object_type-hour {
            background: white;
            color: $colorAppHours;
          }
          &.object_type-contact {
            background: white;
            color: $colorAppCosts;
          }
          &.object_type-gekko_notification {
            color: #88ddb6;
            > svg { transform: rotate(15deg); }
          }
          
        }
      }
      .item-description {
        min-width: 0;
        display: flex;
        justify-content: space-between;
        flex: 1;
        margin-left: 12px;
        font-size: 14px;
        color: rgb(107, 114, 128);
        line-height: 1.3;
        &--action {
          margin: 0;
          a {
            font-family: DINNextLTPro-Medium, sans-serif;
            color: $colorTextBase;
          }
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;  
        }
        &--date {
          text-align: right;
          white-space: nowrap;
          padding-left: 0.5rem;
          .item-year {
            font-size: 12px;
            color: #b7b7b7;
            display: block;
          }
        }
      }
      
    }
    &:last-child {
      padding-bottom: 1rem;
      .line { display: none; }
    }
    &.size-lg {
      .item-description {
        margin-left: 1rem;
      }
      .item-description--date {
        margin-left: 1rem;
        font-size: 1rem;
        .item-year {
          font-size: 14px;
        }
      }
      .item-description--action {
        font-size: 1rem;
      }
      li.activity-list-item {
        padding-bottom: 2rem;
      }
    }
  }
</style>